import cx from 'classnames'
import * as React from 'react'
import Measure from 'react-measure'
import { animated, Keyframes } from 'react-spring'

import { prevAngle } from '../../icons'
import type { LinkViewModel } from '../../view-models/LinkViewModel'
import type { SearchBarViewModel } from '../../view-models/SearchBarViewModel'
import type { ServiceMenuViewModel } from '../../view-models/ServiceMenuViewModel'
import Icon from '../Icon/Icon'
import Link from '../Link/Link'
import NotificationCount from '../NotificationCount/NotificationCount'
import ServiceMenuMobile from '../ServiceMenuMobile/ServiceMenuMobile'
import styles from './sideMenuMobile-style.css'

//TODO: any
//Just installing the react-spring type was not enough.
const Sidebar: any = Keyframes.Spring({
  open: {
    delay: 0,
    x: 0,
  },
  close: async (call) => {
    await call({
      delay: 0,
      x: -100,
    })
  },
})

//TODO: any
//Just installing the react-spring type was not enough.
const Content: any = Keyframes.Trail({
  open: {
    x: 0,
    opacity: 1,
    delay: 50,
  },
  close: {
    x: -100,
    opacity: 0,
    delay: 0,
  },
})

type Props = {
  isOpen: boolean
  currentLinksOpen: boolean
  mobileCurrentItems: Array<any>
  topLevelLinks?: Array<LinkViewModel>
  serviceMenu?: ServiceMenuViewModel
  onBackClick: (...args: Array<any>) => any
  searchBtn?: SearchBarViewModel
  notificationCount?: string
  myPageLink?: LinkViewModel
  onSubmit?: (...args: Array<any>) => any
}
type State = {}

class SideMenuMobile extends React.Component<Props, State> {
  static displayName = 'SideMenuMobile'
  static defaultProps = {}

  componentDidUpdate(prevProps: any): void {
    if (prevProps.isOpen !== this.props.isOpen) {
      const body = document.getElementsByTagName('body')[0]

      if (this.props.isOpen) {
        setTimeout(() => {
          body.style.overflow = 'hidden'
          body.style.height = '100vh'
          body.style.width = '100vw'
        }, 400)
      } else {
        //reset
        body.style.overflow = 'visible'
        body.style.width = 'auto'
        body.style.height = 'auto'
      }
    }
  }

  render() {
    const {
      isOpen,
      mobileCurrentItems,
      currentLinksOpen,
      topLevelLinks,
      serviceMenu,
      onBackClick,
      searchBtn,
      myPageLink,
      notificationCount,
      onSubmit,
    } = this.props
    const sidebarState = isOpen ? 'open' : 'close'
    const currentLinksState = currentLinksOpen ? 'open' : 'close'
    const topLevelLinksState =
      currentLinksOpen && isOpen ? 'close' : !currentLinksOpen && isOpen ? 'open' : 'close'
    if (!mobileCurrentItems) return null

    return (
      <Sidebar native state={sidebarState}>
        {({ x }) => (
          <animated.div
            className={cx(styles.sideMenu, isOpen && styles.isOpen)}
            style={{
              transform: x.interpolate((x) => `translate3d(${x}%,0,0)`),
            }}
          >
            <Measure bounds>
              {({ measureRef, contentRect }) => (
                <div
                  className={styles.contentHolder}
                  style={{
                    height: contentRect.bounds.height,
                  }}
                >
                  <div ref={measureRef}>
                    <div
                      className={cx(
                        !currentLinksOpen && topLevelLinks && isOpen && styles.absolute,
                        !currentLinksOpen && topLevelLinks && styles.disabled,
                      )}
                    >
                      <Content
                        native
                        items={mobileCurrentItems}
                        keys={mobileCurrentItems.map((_, i) => i)}
                        reverse={!isOpen}
                        state={currentLinksState}
                      >
                        {(item, i) => ({ x, ...props }) => {
                          if (typeof item === 'string' && i === 0) {
                            return (
                              <animated.div
                                style={{
                                  transform: x.interpolate((x) => `translate3d(${x}%,0,0)`),
                                  ...props,
                                }}
                                className={styles.backStringHolder}
                                onClick={onBackClick}
                              >
                                <div className={styles.backString}>
                                  <Icon
                                    iconSrc={prevAngle}
                                    className={styles.prevAngle}
                                    width="4px"
                                    height="10px"
                                  />
                                  <div>{item}</div>
                                </div>
                              </animated.div>
                            )
                          } else if (myPageLink && i === mobileCurrentItems.length - 1) {
                            return (
                              <animated.div
                                style={{
                                  transform: x.interpolate((x) => `translate3d(${x}%,0,0)`),
                                  ...props,
                                }}
                                className={cx(styles.menuItemHolder, styles.myPageLink)}
                              >
                                <Link
                                  {...item}
                                  className={cx(styles.menuItem, {
                                    [styles.linkActive]: item.active,
                                  })}
                                  secondary
                                >
                                  <div
                                    style={{
                                      position: 'relative',
                                    }}
                                  >
                                    {item.label}
                                    {notificationCount && (
                                      <NotificationCount notificationCount={notificationCount} />
                                    )}
                                  </div>
                                  <Icon
                                    className={styles.nextAngle}
                                    iconName="ArrowRight"
                                    width="32px"
                                    height="32px"
                                  />
                                </Link>
                              </animated.div>
                            )
                          }

                          return (
                            <animated.div
                              style={{
                                transform: x.interpolate((x) => `translate3d(${x}%,0,0)`),
                                ...props,
                              }}
                              className={styles.menuItemHolder}
                            >
                              <Link
                                {...item}
                                className={cx(styles.menuItem, {
                                  [styles.linkActive]: item.active,
                                })}
                                secondary
                              >
                                {item.label}
                                <Icon
                                  className={styles.nextAngle}
                                  iconName="ArrowRight"
                                  width="32px"
                                  height="32px"
                                />
                              </Link>
                            </animated.div>
                          )
                        }}
                      </Content>
                    </div>
                    {topLevelLinks && (
                      <div
                        className={cx(
                          (currentLinksOpen || (!currentLinksOpen && !isOpen)) && styles.absolute,
                          currentLinksOpen && styles.disabled,
                        )}
                      >
                        <Content
                          native
                          items={topLevelLinks}
                          keys={topLevelLinks.map((_, i) => i)}
                          reverse={!isOpen}
                          state={topLevelLinksState}
                        >
                          {(item, i) => ({ x, ...props }) => {
                            return (
                              <animated.div
                                style={{
                                  transform: x.interpolate((x) => `translate3d(${x}%,0,0)`),
                                  ...props,
                                }}
                                className={cx(styles.menuItemHolder, i === 0 && styles.first)}
                              >
                                <Link
                                  {...item}
                                  className={cx(styles.menuItem, {
                                    [styles.linkActive]: item.active,
                                  })}
                                  secondary
                                >
                                  {item.label}
                                  <Icon
                                    className={styles.nextAngle}
                                    iconName="ArrowRight"
                                    width="32px"
                                    height="32px"
                                  />
                                </Link>
                              </animated.div>
                            )
                          }}
                        </Content>
                      </div>
                    )}
                  </div>
                </div>
              )}
            </Measure>
            {serviceMenu && (
              <ServiceMenuMobile
                serviceMenu={serviceMenu}
                searchBtn={searchBtn}
                isOpen={isOpen}
                onSubmit={onSubmit}
              />
            )}
          </animated.div>
        )}
      </Sidebar>
    )
  }
}

export default SideMenuMobile